(() => {
  const bar = document.querySelector(".announcement-bar");
  if (!bar) return;
  const root = document.documentElement;
  let previousY = Math.max(0, window.scrollY);
  let travel = 0;
  let direction = 0;
  let hidden = previousY > 80;
  let frame = 0;

  const render = () => {
    const height = bar.offsetHeight;
    root.style.setProperty("--announcement-offset", `${hidden ? -height : 0}px`);
    root.style.setProperty("--announcement-scale", hidden ? ".98" : "1");
    root.style.setProperty("--announcement-opacity", hidden ? "0" : "1");
    root.style.setProperty("--announcement-radius", hidden ? "14px" : "0px");
    root.style.setProperty("--announcement-glint", "0");
    root.style.setProperty("--announcement-reveal", `${hidden ? 0 : height}px`);
    bar.classList.toggle("is-hidden", hidden);
    bar.inert = hidden;
    bar.setAttribute("aria-hidden", String(hidden));
  };
  const update = () => {
    frame = 0;
    // Ignore elastic overscroll at both document edges.
    const maxY = Math.max(0, root.scrollHeight - window.innerHeight);
    const y = Math.max(0, Math.min(window.scrollY, maxY));
    const delta = y - previousY;
    previousY = y;
    if (Math.abs(delta) < .5) return;
    const nextDirection = Math.sign(delta);
    travel = nextDirection === direction ? travel + Math.abs(delta) : Math.abs(delta);
    direction = nextDirection;
    let nextHidden = hidden;
    if (y < 8 || bar.contains(document.activeElement)) nextHidden = false;
    else if (travel >= 12) nextHidden = direction > 0;
    if (nextHidden !== hidden) {
      hidden = nextHidden;
      render();
    }
  };
  window.addEventListener("scroll", () => {
    if (!frame) frame = requestAnimationFrame(update);
  }, {passive: true});
  window.addEventListener("resize", render, {passive: true});
  window.addEventListener("pageshow", () => {
    previousY = Math.max(0, window.scrollY);
    hidden = previousY > 80;
    travel = 0;
    direction = 0;
    render();
  });
  render();
})();
